import React from "react";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";

const services = [
  {
    id: 1,
    title: "Luxury Vehicle Rentals: Drive in Style",
    description:
      "Experience the ultimate in luxury and performance with our premium vehicle rentals. Whether you're seeking elegance for a special event, power for an exhilarating drive, or sophistication for a business trip, we offer a fleet of high-end, meticulously maintained vehicles designed to impress. No branding, no hassle—just a seamless, first-class driving experience. Reserve yours today!",
  },
  {
    id: 2,
    title: "Elite Direct Transfer Sprinter Services",
    description:
      "Experience unmatched luxury and discretion with Empire Motors, the premier choice for high-end transportation. We specialize in serving hotels, athletes, entertainers, executives, and music industry professionals, providing seamless travel with the utmost privacy and security. Our Sprinter services offer spacious comfort, top-tier amenities, and optional private security, ensuring a stress-free journey to any destination—near or far. Travel in style, wherever the road takes you.",
  },
  {
    id: 3,
    title: "Luxury Hourly Sprinter Transfers",
    description:
      "At Empire Motors, your journey is our priority. Our Hourly Sprinter Transfer service offers the perfect blend of luxury, flexibility, and convenience, ensuring every ride is as seamless as it is stylish. Whether you're indulging in a glamorous night out, exploring Temecula’s finest wineries, or making multiple stops across the city, our premium Sprinter service guarantees a stress-free, first-class experience from start to finish. Your ride, your schedule—elevated.",
  },
];

const ServicesSection = () => {
  const navigate = useNavigate();
  return (
    <section className="py-16 ">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-10">
          Types of Services We Offer
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white p-6 rounded-2xl shadow-lg border border-gray-200 flex flex-col items-start text-left"
            >
              <div className="w-10 h-10 flex items-center justify-center text-[#B4B4B4] text-lg font-bold border-2 border-[#B4B4B4] rounded-2xl mb-4">
                {service.id}
              </div>
              <h3 className="text-xl font-semibold text-[#121212] mb-4">
                {service.title}
              </h3>
              <p className="text-[[#121212CC] mb-6">{service.description}</p>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-12">
          <ButtonPrimary onClick={() => navigate("/events")}>
            Book Now
          </ButtonPrimary>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
